// Módulo Produtos (catálogo de produtos do cliente) — liberado para TODAS as empresas desde 29/10/2026
// (homologação concluída com o CNPJ de testes 52386933000162).
// Sem imports de Vue/webpack de propósito: este arquivo roda também no teste com node puro.
//
// A API (ProdutosLiberacaoHelper) aplica a mesma regra: basta ter uma empresa ativa identificada.

// `cnpj` = CNPJ da empresa ativa (store.getters.cnpjAtivo); vale com ou sem máscara.
export const produtosLiberado = (cnpj) => /\d/.test(String(cnpj ?? ''));

// Texto da disponibilidade na lista (o banco guarda o valor curto do formulário). Vazio = traço; valor desconhecido
// aparece como está.
const ROTULOS_DISPONIBILIDADE = { pronta: 'Pronta entrega', encomenda: 'Sob encomenda' };
export const rotuloDisponibilidade = (v) => {
    const t = String(v ?? '').trim();
    if (!t) return '—';
    return ROTULOS_DISPONIBILIDADE[t.toLowerCase()] || t;
};
